// Derive the "what page am I on" descriptor for the AI chat from the SPA's
// current location. Pure function (no React) so it is unit-testable and can be
// imported from the node test runner. The chat sends { kind, ref } to the
// server, which re-resolves the live entity; `label` is the terse chip text.
//
// Routes live under /p/:projectTitle/* (see web/src/App.jsx); strip that prefix
// and match the remainder against the project-scoped route table. Per-beat
// dialog/scenes regexes are checked before the bare index paths.
//
// Pass a basename-relative pathname (react-router's useLocation().pathname), NOT
// window.location.pathname: the /p/:title prefix strip assumes no app base-path
// prefix is present, so a raw location under a non-"/" base would bucket every
// page to overview.

export function pageContextFromPath(pathname) {
  const remainder = String(pathname || '').replace(/^\/p\/[^/]+/, '').replace(/\/$/, '') || '/';

  const beat = remainder.match(/^\/beat\/(.+)$/);
  if (beat) {
    const ref = decodeURIComponent(beat[1]);
    return { kind: 'beat', ref, label: `Beat ${ref}` };
  }
  // The artwork section is a sub-view of a beat — it shares the beat's server
  // context (there is no distinct 'artwork' kind), only the chip label differs.
  const artworkBeat = remainder.match(/^\/artwork\/(.+)$/);
  if (artworkBeat) {
    const ref = decodeURIComponent(artworkBeat[1]);
    return { kind: 'beat', ref, label: `Artwork · Beat ${ref}` };
  }
  const character = remainder.match(/^\/character\/(.+)$/);
  if (character) {
    const ref = decodeURIComponent(character[1]);
    return { kind: 'character', ref, label: `Character: ${ref}` };
  }
  const set = remainder.match(/^\/set\/(.+)$/);
  if (set) {
    const ref = decodeURIComponent(set[1]);
    return { kind: 'set', ref, label: `Set: ${ref}` };
  }
  const dialogBeat = remainder.match(/^\/dialog\/(.+)$/);
  if (dialogBeat) {
    const ref = decodeURIComponent(dialogBeat[1]);
    return { kind: 'dialog', ref, label: `Dialog · Beat ${ref}` };
  }
  const scenesBeat = remainder.match(/^\/scenes\/(.+)$/);
  if (scenesBeat) {
    const ref = decodeURIComponent(scenesBeat[1]);
    return { kind: 'scenes', ref, label: `Scenes · Beat ${ref}` };
  }
  if (remainder === '/scenes') return { kind: 'scenes-index', ref: null, label: 'Scenes' };
  if (remainder === '/dialog') return { kind: 'dialog-index', ref: null, label: 'Dialogs' };
  if (remainder === '/notes') return { kind: 'notes', ref: null, label: 'Notes' };
  if (remainder === '/library') return { kind: 'library', ref: null, label: 'Library' };
  if (remainder === '/about') return { kind: 'about', ref: null, label: 'About' };

  return { kind: 'overview', ref: null, label: 'Overview' };
}
